<template>
  <v-container>
    <br>
    <BorderedContainer
      v-if="displayChannelSelectConfig"
      label="Default Channel Display">
      <v-row>
        <v-col cols="3" class="align-vertical no-padding">
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="radioGroup">
                <v-radio
                  :label="returnRBName(1)"
                  :value="returnRBName(1).toLowerCase()"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-radio-group v-model="radioGroup">
                <v-radio
                  :label="returnRBName(2)"
                  :value="returnRBName(2).toLowerCase()"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="4" class="align-vertical no-padding">
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="selectedChannels"
                :items="singleMap"
                item-text="label"
                :disabled="radioGroup == 'combination'"
                @change="parseDisplayVal($event, 'setDisplayOption', 'Display / Default Channel Display')"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedChannels"
                :items="combinationMap"
                item-text="label"
                :disabled="radioGroup == 'single'"
                @change="parseDisplayVal($event, 'setDisplayOption', 'Display / Default Channel Display')"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </BorderedContainer>

    <v-row>
      <v-col cols="12" class="align-vertical">
        <span>Show the following labels on external display:</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col 
        v-for="(label, index) in labels"
        :key="index"
        cols="12"
        class="align-vertical no-padding"
      >
        <v-checkbox
          v-model="selected"
          :label="labelMap(label.name[0])"
          :value="label.name[0]"
          @change="parseNewVal(label.name[0], labelMap(label.name[0]))"
        />
      </v-col>
    </v-row>  
  </v-container>
</template>

<script>

import BorderedContainer from '../components/BorderedContainer.vue';

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

// import { Logger } from "aws-amplify";
// const logger = new Logger("App");

export default {
  name: 'Display',
  components: {
    BorderedContainer
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      radioGroup: '',
      deviceMapRules: {
        // Standard DRV
        'CAMERAMATICS_JH4-HD-4G': {
          singleMap: [
            {
              xml: 'chn1',
              label: '1'
            },
            {
              xml: 'chn2',
              label: '2'
            },
            {
              xml: 'chn3',
              label: '3'
            },
            {
              xml: 'chn4',
              label: '4'
            }
          ],
          combinationMap: [
            {
              xml: 'all',
              label: 'All'
            },
            {
              xml: 'chn1_2',
              label: '1,2'
            },
            {
              xml: 'chn2_3',
              label: '2,3'
            },
            {
              xml: 'chn3_4',
              label: '1,3'
            },
            {
              xml: 'chn1_3',
              label: '1,3'
            },
            {
              xml: 'chn2_4',
              label: '2,4'
            }
          ],
        },
        // 8 Channel DVR
        'CAMERAMATICS_JH8-HD-4G': {
          singleMap: [
            {
              xml: 'chn1',
              label: '1'
            },
            {
              xml: 'chn2',
              label: '2'
            },
            {
              xml: 'chn3',
              label: '3'
            },
            {
              xml: 'chn4',
              label: '4'
            },
            {
              xml: 'chn5',
              label: '5'
            },
            {
              xml: 'chn6',
              label: '6'
            },
            {
              xml: 'chn7',
              label: '7'
            },
            {
              xml: 'chn8',
              label: '8'
            }
          ],
          combinationMap: [
            {
              xml: 'all',
              label: 'All'
            },
            {
              xml: 'chn1_2',
              label: '1,2'
            },
            {
              xml: 'chn3_4',
              label: '3,4'
            },
            {
              xml: 'chn5_6',
              label: '5,6'
            },
            {
              xml: 'chn7_8',
              label: '7,8'
            },
            {
              xml: 'chn1_2_3',
              label: '1,2,3'
            },
            {
              xml: 'chn4_5_6',
              label: '4,5,6'
            },
            {
              xml: 'chn1_2_3_4',
              label: '1,2,3,4'
            },
            {
              xml: 'chn5_6_7_8',
              label: '5,6,7,8'
            },
          ],
        },
        // New gen 4 chan
        'CAMERAMATICS_JH4_NT-HD-4G': {
          singleMap: [
            {
              xml: 'chn1',
              label: '1'
            },
            {
              xml: 'chn2',
              label: '2'
            },
            {
              xml: 'chn3',
              label: '3'
            },
            {
              xml: 'chn4',
              label: '4'
            }
          ],
          combinationMap: [
            {
              xml: 'all',
              label: 'All'
            },
            {
              xml: 'chn1_2',
              label: '1,2'
            },
            {
              xml: 'chn2_3',
              label: '2,3'
            },
            {
              xml: 'chn3_4',
              label: '1,3'
            },
            {
              xml: 'chn1_3',
              label: '1,3'
            },
            {
              xml: 'chn2_4',
              label: '2,4'
            }
          ],
        },
        // New gen 8 chan
        'CAMERAMATICS_JH8_NT-HD-4G': {
          singleMap: [
            {
              xml: 'chn1',
              label: '1'
            },
            {
              xml: 'chn2',
              label: '2'
            },
            {
              xml: 'chn3',
              label: '3'
            },
            {
              xml: 'chn4',
              label: '4'
            },
            {
              xml: 'chn5',
              label: '5'
            },
            {
              xml: 'chn6',
              label: '6'
            },
            {
              xml: 'chn7',
              label: '7'
            },
            {
              xml: 'chn8',
              label: '8'
            }
          ],
          combinationMap: [
            {
              xml: 'all',
              label: 'All'
            },
            {
              xml: 'chn1_2',
              label: '1,2'
            },
            {
              xml: 'chn3_4',
              label: '3,4'
            },
            {
              xml: 'chn5_6',
              label: '5,6'
            },
            {
              xml: 'chn7_8',
              label: '7,8'
            },
            {
              xml: 'chn1_2_3',
              label: '1,2,3'
            },
            {
              xml: 'chn4_5_6',
              label: '4,5,6'
            },
            {
              xml: 'chn1_2_3_4',
              label: '1,2,3,4'
            },
            {
              xml: 'chn5_6_7_8',
              label: '5,6,7,8'
            },
          ],
        },
        // D700 DVR
        'CAMERAMATICS_D700-SD-4G': {
          singleMap: [
            {
              xml: 'chn1',
              label: '1'
            },
            {
              xml: 'chn2',
              label: '2'
            },
            {
              xml: 'chn3',
              label: '3'
            },
            {
              xml: 'chn4',
              label: '4'
            }
          ],
          combinationMap: [
            {
              xml: 'all',
              label: 'All'
            },
            {
              xml: 'chn1_2',
              label: '1,2'
            },
            {
              xml: 'chn2_3',
              label: '2,3'
            },
            {
              xml: 'chn3_4',
              label: '1,3'
            },
            {
              xml: 'chn1_3',
              label: '1,3'
            },
            {
              xml: 'chn2_4',
              label: '2,4'
            }
          ],
        },
      },
      selected: [],
      testingOption: '',
      selectedChannels: ''
    }
  },
  computed: {
    labels() {
      return this.config.device_config.video[0].display[0].labels[0].label;
    },
    selectedOption() {
      return this.config.device_config.video[0].display[0].defaultChannelDisplay[0].selectedOption[0];
    },
    singleMap() {
      return this.deviceMapRules[this.deviceModel]['singleMap'];
    },
    combinationMap() {
      return this.deviceMapRules[this.deviceModel]['combinationMap'];
    },
    displayChannelSelectConfig() {
      if(this.deviceModel == 'CAMERAMATICS_D700-SD-4G') {
        return false
      }

      if(this.deviceModel == 'CAMERAMATICS_JI7A-SD-4G') {
        return false
      }
      else {
        return true
      }
    }
  },
  watch: {
    radioGroup(val) {
      this.prePopChannelSettings(val)
    }
  },
  mounted() {
    this.parseLabelState();
    this.setDefaultChannelDisplay();
  },
  methods: {
    prePopChannelSettings(type) {
      let set = type == 'single' ? this.singleMap : this.combinationMap;
      let hasVal = set.find(item => item.xml == this.selectedOption) ;
      let defaultVal = '';
      
      if(hasVal) {
        defaultVal = hasVal.label
      }
      else {
        defaultVal = set[0].label;
      }
      
      this.selectedChannels = defaultVal;
    },
    setDefaultChannelDisplay() {
      if(this.deviceModel == 'CAMERAMATICS_JH4-HD-4G' || this.deviceModel == 'CAMERAMATICS_JH8-HD-4G' || this.deviceModel == 'CAMERAMATICS_JH4_NT-HD-4G' || this.deviceModel == 'CAMERAMATICS_JH8_NT-HD-4G') {
        let singleOptions = this.checkOptionsMap(this.singleMap);
        let comboOptions = this.checkOptionsMap(this.combinationMap);

        if(singleOptions) {
          // Using single channel display
          this.populateDisplaySettings('single', singleOptions.label)
        }

        if(comboOptions) {
          // Using combination channel display
          this.populateDisplaySettings('combination', comboOptions.label)
        }
      }
    },
    populateDisplaySettings(group, label) {
      this.radioGroup = group;
      this.selectedChannels = label;
    },
    checkOptionsMap(options) {
      let result = options.find(option => {
        return option.xml === this.selectedOption;
      });

      return result;
    },
    returnRBName(id) {
      let label = '';
      
      switch(id) {
        case 1:
          label = 'Single';
          break;
        case 2:
          label = 'Combination';
          break;
        default:
      }

      return label;
    },
    labelMap(label) {
      let map = {
        ioState: 'IO Pin State',
        gps: 'GPS Coordinates',
        speed: 'Speed',
        channelName: 'Channel Name',
        speedLimit: 'Speed Limit'
      };

      return map[label];
    },
    parseLabelState() {
      this.labels.forEach(label => {
        if (label.show[0] === 'true') {
          this.selected.push(label.name[0]);
        }
      });
    },
    parseNewVal(id, label) {
      let payload = {
        newValue: this.returnMappedVal(this.checkIfInArray(id), [this.singleMap, this.combinationMap]),
        key: this.configPropMapper(id),
        label: label,
        context: {
          newValue: id,
          key: this.configPropMapper(`${id}Label`),
          label: 'name'
        }
      }

      this.$emit('settingsUpdated', payload);
    },
    parseDisplayVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.singleMap, this.combinationMap]),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload);
    },
    checkIfInArray(val) {
      return this.selected.includes(val);
    },
    configPropMapper(key) {
      let map = {
        'ioState': 'device_config.video[0].display[0].labels[0].label[0].show[0]',
        'ioStateLabel': 'device_config.video[0].display[0].labels[0].label[0].name[0]',
        'gps': 'device_config.video[0].display[0].labels[0].label[1].show[0]',
        'gpsLabel': 'device_config.video[0].display[0].labels[0].label[1].name[0]',
        'speed': 'device_config.video[0].display[0].labels[0].label[2].show[0]',
        'speedLabel': 'device_config.video[0].display[0].labels[0].label[2].name[0]',
        'channelName': 'device_config.video[0].display[0].labels[0].label[3].show[0]',
        'channelNameLabel': 'device_config.video[0].display[0].labels[0].label[3].name[0]',
        'speedLimit': 'device_config.video[0].display[0].labels[0].label[4].show[0]',
        'speedLimitLabel': 'device_config.video[0].display[0].labels[0].label[4].name[0]',
        'setDisplayOption': 'device_config.video[0].display[0].defaultChannelDisplay[0].selectedOption[0]',
      }

      return map[key];
    }
  }
}
</script>

<style lang="scss" scoped>
  .align-vertical {
    justify-content: left;
    align-items: center;
    display: flex;
  }
  .no-padding {
    padding: 0 .5em !important;
    margin: 0 !important;
  }
  .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
</style>